let appConfig = require('../../config/index.js')
const ALL_API = {
  // 寄存/提取单列表
  getDepositList: {
    method: 'get',
    url: '/api/deposit/list'
  },
  // 获取寄存商品
  getDepositSku: {
    method: 'get',
    url: '/api/deposit/sku'
  }
  ,
  // 获取寄存详情
  getDepositInfo: {
    method: 'get',
    url: '/api/deposit/info'
  }
}

export default ALL_API



// WEBPACK FOOTER //
// ./src/api/deposit/index.js